module.exports = __webpack_public_path__ + "assets/img/tab3_03.eeade247.jpg";